import React from "react"
import { useParams, Outlet, useLocation } from "react-router-dom"

import { Tabs, TabList, Tab, TabPanel, TabPanels } from "@chakra-ui/react"
import Link from "./Link"

export default function SchemaTabs() {
  const { datasetId, schemaId } = useParams()
  const location = useLocation()

  const getTabIndex = React.useCallback(() => {
    if (location.pathname.includes("/records")) {
      return 0
    } else if (location.pathname.includes("/permissions")) {
      return 2
    } else {
      return 1
    }
  }, [location.pathname])

  return (
    <Tabs variant="base" index={getTabIndex()}>
      <TabList>
        <Tab>
          <Link to={`/datasets/${datasetId}/schemas/${schemaId}/records`}>
            Records
          </Link>
        </Tab>
        <Tab>
          <Link to={`/datasets/${datasetId}/schemas/${schemaId}`}>Schema</Link>
        </Tab>
        <Tab>
          <Link to={`/datasets/${datasetId}/schemas/${schemaId}/permissions`}>
            Permissions
          </Link>
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
        <TabPanel>
          <Outlet />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}
